// @flow

export default () => process.env.LISTO_FLAG_USE_CONFIG_VALIDATION === 'true';
